import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { ERROR_ACCESS_DENIED } from '@/constants/constant-routes';

interface ManagementOnlyRouteProps {
  children: ReactNode;
}

export default function ManagementOnlyRoute({ children }: ManagementOnlyRouteProps) {
  const { isManagementTenant } = useAuth();

  if (!isManagementTenant) {
    return <Navigate to={ERROR_ACCESS_DENIED} replace />;
  }

  return <>{children}</>;
}
